import React from "react";
import styles from "./journalmobilecard.module.css";
import { Edit, Trash2, MoreVertical, AlertTriangle } from "react-feather";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";

const JournalMobileCard = ({ item, tenantList, setDeleteId, setDeleteModalOpen, setJournalDetails, setOpenEditForm, setLoading }) => {
    const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();

    const getJouranalDetails = async () => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios(process.env.REACT_APP_TENANT_API_URL + "v1/journals/" + item?.id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setOpenEditForm(true);
            setJournalDetails(response.data.data);
        }).catch(() => {
            setLoading(false);
        });
    }

    const getTenantNames = () => {
        if (item?.tenant_names) {
            return item.tenant_names;
        }
        if (item?.tenant_name) {
            return item.tenant_name;
        }
        if (item?.tenants && tenantList?.length > 0) {
            const tenantIds = String(item.tenants).split(",").map(id => parseInt(id.trim(), 10));
            const names = tenantIds
                .map(id => {
                    const match = tenantList.find(t => t.value === id);
                    return match ? match.label : null;
                })
                .filter(name => name !== null);
            if (names.length > 0) {
                return names.join(", ");
            }
        }
        return "";
    };

    const tenantNamesStr = getTenantNames();
    const categoryLabel = item?.is_unusual === 1 ? "INCIDENT" : "NOTE";
    const badgeStyleClass = item?.is_unusual === 1 ? styles.incidentBadge : styles.noteBadge;
    const snippet = item?.description ? item.description.replace(/<[^>]*>/g, '') : '';

    return (
        <Link to={"/security/journal/details/" + item?.id} className={`${styles.JournalListCard}`}>
            <div className={`${styles.JournalImageSec}`}>
                <p>{item?.user_initial || "U"}</p>
            </div>
            <div className={`${styles.JournalDesSec}`}>
                <div className={styles.TitleRow}>
                    <span className={styles.Title}>{item?.title || "Journal Entry"}</span>
                    {item?.is_unusual === 1 && <AlertTriangle className={styles.unusualIcon} />}
                </div>
                <p className={`${styles.JournalTextSec}`}>
                    {item?.user_name} 
                    <span>{item?.property_name}</span>
                    {dayjs(item?.date).isValid() && <span>{dayjs(item?.date).format("MMM DD, YYYY")}</span>}
                </p>
                <div className={`${styles.SummCommBodyText}`}>{snippet}</div>
            </div>

            {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("journal:update") > -1 || user["https://propertydek.com/permissions"].indexOf("journal:delete") > -1) && (
                <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                    <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                        <MoreVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("journal:update") > -1 && (
                            <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { getJouranalDetails(); }}>
                                <Edit /> Edit
                            </Dropdown.Item>
                        )}
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("journal:delete") > -1 && (
                            <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteId(item?.id); setDeleteModalOpen(true); }}>
                                <Trash2 /> Delete
                            </Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                </Dropdown>
            )}
        </Link>
    );
};

export default JournalMobileCard;